<template lang="pug">
div
  modal-add-file(:changeOrder="selectedChangeOrder" :isVisible="isModalAddFileVisible" @closeModal="closeModalAddFile" @submit="addFile" :is-add='isModalAdd')
  vm-table.table(max-height="350px" :data="changeOrders")
    template(slot="thead")
      vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns") {{ $t('change_orders.' + column) }}
    template(slot-scope="{data}")
      vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data" v-if="data[indextr]['project_id'] == projectId")
        vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
          slot(v-if="column !== 'created_at' && column !== 'created_at' && column !== 'type' && column !== 'amount'") {{ data[indextr][column] }}
          slot(v-if="column == 'amount'")  {{ data[indextr][column] | currency }}
          slot(v-if="column == 'type'")  {{ data[indextr][column] == '1' ? $t('projects_dashboard.additive')  : $t('projects_dashboard.deductible')  }}
          slot(v-if="column == 'created_at'")  {{ data[indextr][column] | moment("DD MMMM YYYY").toUpperCase() }}
          img.icon#icon_show_pdf(v-if="column == 'pdf' && data[indextr]['file'] != null" src="@/assets/pdf.svg" style="padding-top: 0.6rem;" @click="download(data[indextr]['file_public_url'])")
          slot(v-if="column == 'pdf' && data[indextr]['file'] == null") NO ASIGNADO
        vm-td
        vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
          vm-button(type="flat" icon="more-horizotnal" color="#afbbc6")
          vm-dropdown-menu
            vm-dropdown-item.d-flex.justify-content-between(@click="showModalAddPdf(changeOrders[indextr])" v-if="changeOrders[indextr]['file'] == null" )
              vm-icon(icon="file-add-outline")
              slot &nbsp;{{ $t('strings.add_pdf') }}
            vm-dropdown-item.d-flex.justify-content-between(@click="deleteRecordConfirm(changeOrders[indextr])")
              vm-icon(icon="trash-2-outline")
              slot &nbsp;{{ $t('strings.delete') }}
  vm-pagination.pagination(:total="pagination.totalPages" v-model="currentPage" goto)
</template>

<script>
import ViewMixinMaster1 from '@/mixins/ViewMixinMaster1'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('ChangeOrders')
const ModalAddFile = () => import('@/components/modals/ModalAddFile.vue')

export default {
  components: {
    ModalAddFile
  },
  mixins: [ViewMixinMaster1],
  props: {
    projectId: {
      type: Number,
      default: 0
    }
  },
  data: () => ({
    file: null,
    currentPage: 1,
    date: '',
    columns: ['type', 'description', 'amount', 'created_at', 'pdf'],
    filters: {
      project_id: null
    },
    selectedChangeOrder: {},
    isModalAddFileVisible: false,
    attributeModal: 'description'
  }),
  computed: {
    ...mapGetters([
      'changeOrders',
      'pagination'
    ])
  },
  watch: {
    async currentPage (value) {
      this.loadRecords({ page: value })
    }
  },
  async created () {
    this.filters = {
      project_id: this.$route.params.id
    }
    this.applyFilter(this.filters)
    await this.loadRecords({ page: this.currentPage })
  },
  methods: {
    ...mapActions([
      'deleteRecord',
      'loadRecords',
      'exportChangeOrder',
      'applyFilter',
      'export',
      'editChangeOrder'
    ]),
    download (url) {
      this.export(url)
    },
    showModalAddPdf (changeOrder) {
      this.isModalAdd = false
      this.selectedChangeOrder = changeOrder
      this.isModalAddFileVisible = true
    },
    closeModalAddFile () {
      this.isModalAddFileVisible = false
      this.file = null
    },
    addFile (file) {
      this.editChangeOrder({ id: this.selectedChangeOrder.id, file: file })
    },
    delete () {
      this.$emit('delete')
    },
    async deleteRecordConfirm (record) {
      let t = this
      this.auxDeleteRecord = async () => {
        await t.deleteRecord({ ...record }).then(() => {
          t.selected = []
        })
        await this.delete()
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', {
          model: this.$t('strings.change_order'),
          attribute: this.$t(record[this.attributeModal])
        }),
        accept: this.auxDeleteRecord
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import './project_dashboard_structure.css';
#icon_show_pdf {
  cursor: pointer;
}
</style>
